export default __webpack_public_path__ + "static/media/student1stop.com.5ba53be3.png";